import { createStyles, makeStyles } from '@material-ui/core';
import { lightGrey } from '@signaturit/react-components-library';

const subMenuItemsBackground = '#FFFFFF';
const hoverSubMenuColor = '#F5F5FF';
const selectedSubMenuColor = '#E0E0F4';
const borderSubMenuColor = '#0304A0';
const fontMenuColor = '#020250';

export const useSideNavigationSubMenuItemsStyles = makeStyles(() =>
    createStyles({
        link: {
            width: '100%',
            color: `${fontMenuColor} !important`,
            textDecoration: 'none',

            '&:hover': {
                textDecoration: 'underline',
            },
        },
        bullet: {
            marginRight: 8,
        },
        subMenuList: {
            width: '100%',
            maxWidth: 224,
            margin: '0 auto',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            backgroundColor: subMenuItemsBackground,
            padding: '8px !important',
            paddingTop: '4px !important',
            borderRadius: '4px',
            borderTopLeftRadius: '0',
            borderTopRightRadius: '0',
            '& div': {
                width: '100%',
            },
            borderTop: '0',
            gap: '4px'
        },
        subMenuListItem: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            height: 40,
            borderRadius: '4px !important',
            border: 'solid 1px transparent',
            '&:hover': {
                backgroundColor: `${hoverSubMenuColor} !important`,
                border: `solid 1px ${borderSubMenuColor}`
            },
            '&$subMenuListItemSelected': {
                backgroundColor: `${selectedSubMenuColor} !important`,
                border: `solid 1px ${borderSubMenuColor}`,
                '&:hover': {
                },
            },
        },
        subMenuListItemWithBullet: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            height: 40,
            borderRadius: '4px !important',
            paddingLeft: '20px !important',
            border: 'solid 1px transparent',
            '&:hover': {
                backgroundColor: `${hoverSubMenuColor} !important`,
                border: `solid 1px ${borderSubMenuColor}`
            },
            '&$subMenuListItemSelected': {
                backgroundColor: `${selectedSubMenuColor} !important`,
                border: `solid 1px ${borderSubMenuColor}`,
                '&:hover': {
                },
            },
        },
        subMenuListItemSelected: {},
        subMenuListItemContent: {
        },
        subMenuListItemContentSelected: {
            fontWeight: 500,
        },
        divider: {
            backgroundColor: lightGrey,
            width: 170,
            margin: 15,
        },
    })
);
